import {FC} from "react";
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	background: #040404;
	gap: 40px;

	@media (min-width: 769px) {
		background: ${({theme}) => theme.background.tertiary};
	}
`;

const Description = styled.div`
	padding: 22px 20px;
	color: ${({theme}) => theme.color.tertiary};
	text-transform: uppercase;
	max-width: 1340px;
	margin: 0 auto;
	width: 100%;

	@media (min-width: 769px) {
		padding: 60px;
	}
`;

const Title = styled.h1`
	font-family: "Khand", sans-serif;
	font-weight: 700;
	line-height: 130%;
	font-size: 16px;

	@media (min-width: 769px) {
		font-size: 34px;
	}
`;

const SubTitle = styled.h2`
	font-family: "Hind", sans-serif;
	font-weight: 500;
	font-size: 18px;
	line-height: 120%;
	letter-spacing: 0.2px;
	display: none;

	@media (min-width: 769px) {
		display: block;
	}
`;

export const UserBadges: FC = () => {
	const {t} = useTranslation();

	return (
		<Wrapper>
			<Description>
				<Title>{t("badges.title")}</Title>
				<SubTitle>{t("badges.sub_title")}</SubTitle>
			</Description>
		</Wrapper>
	);
};
